import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import {Alert} from "react-bootstrap";

class EditFaq extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageId: null,
            faq: {},
            faqCategories: [],
            faqCategory: {},
            success: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentDidMount() {
        let categoryId = this.props.match.params.categoryId;
        let faqId = this.props.match.params.faqId;
        let pageId = this.props.match.params.pageId;
        this.setState({ categoryId : categoryId })
        this.setState({ faqId : faqId })
        this.setState({ pageId : pageId })

        const res = await axios.get(`/api/pages/faqs`)
        const { content } = res.data

        this.setState({ faqCategories : content })

        const categoryIndex = content.findIndex(x => x.id == categoryId);
        let category = content[categoryIndex];

        this.setState({ faqCategory : category })

        const faqIndex = category.items.findIndex(x => x.id == faqId);
        let faq = category.items[faqIndex];

        this.setState({ faq })
    }

    async handleSubmit(e) {
        e.preventDefault();
        let faqsCategories = this.state.faqCategories;
        const categoryIndex = faqsCategories.findIndex(x => x.id == this.state.categoryId);
        let category = faqsCategories[categoryIndex];
        const faqIndex = category.items.findIndex(x => x.id == this.state.faqId);
        category.items[faqIndex] = this.state.faq
        faqsCategories[categoryIndex] = category;

        try {
            const data = {
                title: "Faqs",
                content: faqsCategories
            }
            await axios.put(`/api/pages/faqs`, data);
            this.setState({ success: true });
        } catch (e) {
            console.log(e);
        }
    }

    handleInputChange(value, type) {
        let faq = this.state.faq
        faq[type] = value
        this.setState({ faq })
    }

    render() {
        return (
            <section className="contact-wrapper">
                <div className="container">
                    {
                        this.state.success && <Alert variant="success">Content updated successfully</Alert>
                    }
                    <div className="row justify-content-center">
                        <div className="col-md-8">
                            <div className="contact_form">
                                <h3 className="title">{ this.state.faqCategory.title }</h3>

                                <div id="login">
                                    <div id="message" />
                                    <form
                                        method="post"
                                        onSubmit={this.handleSubmit}>
                                        <input
                                            type="hidden"
                                            name="csrf-token"
                                            value={window.Laravel.csrfToken}
                                        />

                                        <div className="row">
                                            <div className="col-12  form-group">
                                                <label>Question</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Question..."
                                                    required
                                                    value={this.state.faq.q}
                                                    onChange={(e) => this.handleInputChange(e.target.value, 'q')}
                                                />
                                            </div>

                                            <div className="col-12  form-group">
                                                <label>Answer</label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Answer"
                                                    required
                                                    rows="10"
                                                    value={this.state.faq.a}
                                                    onChange={(e) => this.handleInputChange(e.target.value, 'a')}
                                                />
                                            </div>
                                            <div className="submit-btn mt-0">
                                                <input
                                                    className="btn btn-primary"
                                                    value="Submit"
                                                    type="submit"
                                                    name="submit"
                                                    id="submit"
                                                />

                                                <Link to={`/admin/dashboard/pages/${this.state.pageId}/${this.state.categoryId}`}>
                                                    <button
                                                        className="btn btn-warning"
                                                    ><i className="fa fa-undo"></i> Return</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(EditFaq);
